import React from 'react'; 
import FadeIn from "react-lazyload-fadein";
import AgentHighlights from '../agent/AgentHighlights.js';
import Foot from '../global/Foot';
import WithConsumer from '../../context/WithConsumer';

const Agent = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
            
    if (post) {
	    
	    let pageClass = 'c-page-wrapper c-page c-page-' + post.slug + 'c-agent';
		
		if (context.appError || !post.name){
		
			return null; 
		
		} else {
			
			document.documentElement.classList.remove('state-reverse-header');
			document.documentElement.classList.remove('state-minimal-header');
			document.documentElement.classList.add('scope-reverse');
							
			return (
				<>

					<div className={pageClass}>
						
						<div className="c-page__inner">
						
							<div className="c-page__block c-page__block--l-space c-page__block--load-effect scope-reverse">
						
								<div className="l-content l-content--fixed-width">
				    				
				    				<div className="l-grid">
				    				
				    					<div className="l-grid__col">
				    					
				    						<h4 className="c-paragraph c-paragraph--xlarge c-paragraph--l-space" dangerouslySetInnerHTML={{__html:'Team'}}></h4>
										
										</div>
										
									</div>
									
									<div className="l-grid l-grid--m-reverse">
										
										<div className="l-grid__col l-grid__col--m-6-12">
											
											<header className="c-agent__header u-m-hide">
												<h1 className="c-paragraph c-paragraph--xxxlarge" dangerouslySetInnerHTML={{__html:post.name}}></h1>
												<h2 className="c-paragraph c-paragraph--xxxlarge c-paragraph--l-space c-paragraph--faded" dangerouslySetInnerHTML={{__html:post.role}}></h2>
											</header>
											
											{post.srcset &&
										
												<div className="c-agent__headshot">
													<FadeIn>
														{onload => (
															<img
																alt={''} 
																src={post.src} 
																srcSet={post.srcset} 
																onLoad={onload}
															/>
														)}
													</FadeIn>
												</div>	
										
											}
											
										</div>
										
										<div className="l-grid__col l-grid__col--m-6-12">
										
											<header className="c-agent__header u-m-show">
												<h1 className="c-paragraph c-paragraph--xxxlarge" dangerouslySetInnerHTML={{__html:post.name}}></h1>
												<h2 className="c-paragraph c-paragraph--faded c-paragraph--xxxlarge c-paragraph--l-space" dangerouslySetInnerHTML={{__html:post.role}}></h2>
											</header>
											
											{post.phone &&
												<p className="c-paragraph c-paragraph--xlarge" dangerouslySetInnerHTML={{__html:post.phone}}></p>
											}
											{post.email &&
												<p className="c-paragraph c-paragraph--xlarge" dangerouslySetInnerHTML={{__html:post.email}}></p>
											}
											{post.vcf &&
												<p className="c-paragraph c-paragraph--xlarge" dangerouslySetInnerHTML={{__html:post.vcf}}></p>
											}
																						
											{post.biography &&
												<div className="scope-text scope-text--faded" dangerouslySetInnerHTML={{__html:'<br />' + post.biography}}></div>
											}
											
										</div>
										
									</div>
									
								</div>
							
							</div>
							
							{post.highlights.length > 0 &&
								
								<div className="c-page__block c-page__block--l-space c-page__block--load-effect scope-reverse">
									
									<div className="l-content l-content--fixed-width">
				    				
					    				<div className="l-grid">
					    				
					    					<div className="l-grid__col">
					    					
					    						<h4 className="c-paragraph c-paragraph--xlarge c-paragraph--l-space" dangerouslySetInnerHTML={{__html:'Agent Highlights'}}></h4>
					    						
					    						<AgentHighlights projects={post.highlights}></AgentHighlights>
											
											</div>
											
										</div>
										
									</div>
						
								</div>
							
							}
							
							<Foot></Foot>
															
						</div>
						
					</div>
					
				</>
			)
						
		}

	} else {
		return null;
	}
};
export default WithConsumer(Agent);